export default __webpack_public_path__ + "static/media/impressions.b84536f0.csv";